module.exports = __webpack_public_path__ + "static/media/meridith.ed972adb.jpg";